// This script manage product size list show more size button.
// It is hold as external file so that this feature works on each collection section
// without need of adding this script in every file where collection snippet is used
(function($){
  $(function() {
    function updateSizeDisplay($container) {
      const $sizes = $container.find('[data-size-label]');
      const $btn = $container.find('[data-show-more]');

      // Reset
      $sizes.show();
      $btn.off('click').text('+0').css({ visibility: 'hidden', display: 'inline-flex' });

      const containerWidth = $container.width();
      let widthTakenByLabels = 0;
      const hidden = [];

      $sizes.each(function (index, sizeSpan) {
        const $size = $(sizeSpan);

        let sizeLabelWidth = $size.outerWidth(true);
        widthTakenByLabels = widthTakenByLabels + sizeLabelWidth + 4;

        if (widthTakenByLabels > containerWidth) {
          hidden.push($size);
        }
      });

      if (hidden.length > 0) {
        const SVG = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'
        $btn.text('+' + hidden.length);
        $btn.css({ visibility: 'visible', display: 'inline-flex' });
        $btn.on('click', function () {
          $btn.closest('[data-kalis-product-size]').toggleClass('sizes-opened');
          const expanded = $btn.data('expanded') || false;
          if (!expanded) {
            hidden.forEach($s => $s.show());
            $btn.data('expanded', true);
            $btn.html(SVG);
          } else {
            $btn.data('expanded', false);
            $btn.text('+' + hidden.length);
          }
        });
      } else {
        $btn.hide();
      }
    }

    $('[data-kalis-product-size]').each(function () {
      updateSizeDisplay($(this));
    });

    $(window).on('resize', function () {
      $('[data-kalis-product-size]').each(function () {
        updateSizeDisplay($(this));
      });
    });
  });
})(jQuery);